import { render, staticRenderFns } from "./ClassRoomManagement.vue?vue&type=template&id=648eaffd&"
import script from "./ClassRoomManagement.vue?vue&type=script&lang=js&"
export * from "./ClassRoomManagement.vue?vue&type=script&lang=js&"
import style0 from "./ClassRoomManagement.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClassRoomManagement.vue"
export default component.exports